var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17.5523 8 18 7.55228 18 7V3C18 2.44772 17.5523 2 17 2H16.4286C15.8763 2 15.4286 2.44772 15.4286 3V5H13.2857V3C13.2857 2.44772 12.838 2 12.2857 2H11.7143C11.162 2 10.7143 2.44772 10.7143 3V5H8.57143V3C8.57143 2.44772 8.12371 2 7.57143 2H7C6.44772 2 6 2.44772 6 3V7C6 7.51777 6.3935 7.94363 6.89776 7.99484C6.93137 7.99825 6.96548 8 7 8H17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4866 9.5H7.51351C7.29353 12.2856 6.92546 15.1674 6.57678 17.5H17.4234C17.0747 15.1674 16.7066 12.2856 16.4866 9.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C4.44772 19 4 19.4477 4 20V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V20C20 19.4477 19.5523 19 19 19H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRook);
export default __webpack_public_path__ + "static/media/rook.df50e32ded6f55b650afc420c4861df1.svg";
export { ForwardRef as ReactComponent };